import script from "./checklist.vue?vue&type=script&setup=true&lang=js"
export * from "./checklist.vue?vue&type=script&setup=true&lang=js"

import "./checklist.vue?vue&type=style&index=0&id=7016599b&scoped=true&lang=css"

import exportComponent from "/Users/teguhsangra/Web/GSD/xsport/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7016599b"]])

export default __exports__